import "../../auto-mapper/AutoMapperProvider.js";
import { useAutoMapper } from "../../auto-mapper/hooks.js";
import { BonusCodeDetails } from "../../contract/pam.js";
import "typesafe-actions";
import "rxjs";
import "rxjs/operators";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react";
import "react-error-boundary";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import "redux-observable";
import "../../api/types.js";
import "immer";
import "moment-timezone";
import "react-intl";
import "@apollo/client/errors";
import "@apollo/client";
import "graphql";
import "@apollo/client/link/subscriptions";
import "@apollo/client/utilities";
import "cross-fetch";
import "graphql-ws";
import "../../node_modules/moment/dist/moment.js";
import "rxjs/ajax";
import "../../redux-folder/async-action/action.js";
import "../../redux-folder/error-handling/action.js";
import "../../redux-folder/actions.js";
import "fast-deep-equal/es6";
import "redux";
import "../../redux-folder/entity/epics.js";
import "normalizr";
import "../../redux-folder/entity/EntityProvider.js";
import "../../redux-folder/realtime/RealtimeNotification.js";
import "reselect";
import { useViewInit } from "../../redux-folder/view/hooks.js";
import { BonusCodeDetailsViewModelKeysTypeName, BonusCodeQueryFieldsTypeName } from "./constants.js";
import { BonusCodeDetailsViewModel } from "./types.js";
function useBonusCodes({
  realtimeMode,
  triggers,
  ids,
  fields,
  viewType,
  displayName,
  defaultFilters,
  defaultPaging,
  defaultSorting,
  syncWithUrl,
  validateFilter,
  cleanDelay,
  bonusCodeEntityType
}) {
  const mapper = useAutoMapper();
  function getDefaultFilters() {
    const filters = defaultFilters ? [...defaultFilters] : [];
    if (ids?.length > 0) {
      const uniqueUids = getUniqueIds();
      const uidFilter = uniqueUids.join(" ");
      filters.push({ key: "bonusId", value: uidFilter });
    }
    return filters;
  }
  function getUniqueIds() {
    return [...new Set(ids)];
  }
  const {
    items,
    totalCount,
    searchFilter,
    viewEntity: { filter: filterString },
    handleFilterChange,
    handleSortChange,
    handlePageChange,
    handlePageSizeChange
  } = useViewInit({
    viewType,
    entity: {
      entity: bonusCodeEntityType,
      fields: mapFields(fields)
    },
    realtime: realtimeMode && triggers ? { entity: bonusCodeEntityType, mode: realtimeMode, triggers } : null,
    displayName,
    defaultFilters: getDefaultFilters(),
    defaultPaging: ids?.length > 0 ? { page: 1, pageSize: getUniqueIds().length } : defaultPaging,
    validateFilter,
    cleanDelay,
    defaultSorting: mapSorting(defaultSorting),
    syncWithUrl
  });
  const bonusCodeItems = items?.map(
    (i) => mapper.tryMap(i, BonusCodeDetails, BonusCodeDetailsViewModel)
  );
  return {
    items: bonusCodeItems?.map((i) => i.model),
    rawItems: bonusCodeItems?.map((i) => ({ isValid: i.isModelValid, raw: i.rawModelString })),
    totalCount,
    searchFilter,
    filterString,
    handlePageChange,
    handlePageSizeChange,
    handleSortChange: handleVmSortChange,
    handleFilterChange
  };
  function mapFields(fields2) {
    return fields2?.map(
      (field) => mapper.map(
        field,
        BonusCodeDetailsViewModelKeysTypeName,
        BonusCodeQueryFieldsTypeName
      )
    );
  }
  function mapField(field) {
    return mapFields([field])[0];
  }
  function mapSorting(sorting) {
    return sorting?.map((s) => ({ ...s, field: mapField(s.field) }));
  }
  function handleVmSortChange(sorting) {
    handleSortChange(mapSorting(sorting));
  }
}
export {
  useBonusCodes
};
//# sourceMappingURL=hooks.js.map
